import _faTrophyAlt from '@fortawesome/fontawesome-pro-solid/faTrophyAlt';
// import _svgSkull from 'src/images/icons/skull.svg';

export const faTrophyAlt = _faTrophyAlt;
// export const svgSkull = _svgSkull;



// WEBPACK FOOTER //
// ./src/components/icons.js